function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SaveFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 343 228",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F0F9",
    d: "M48 76h247v128H48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AABED",
    d: "M249.362 24H127.597a4 4 0 00-4 4v77.102a4 4 0 004 4h121.765a4 4 0 004-4V28a4 4 0 00-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0071C7",
    d: "M223.006 82.625v71.497a5.701 5.701 0 01-5.7 5.7H63.763a5.7 5.7 0 01-5.7-5.7V64.078a5.7 5.7 0 015.7-5.7h40.302a6.474 6.474 0 016.454 5.975l.408 5.384a7.792 7.792 0 007.768 7.194h98.62a5.7 5.7 0 015.691 5.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222A72",
    d: "M120.937 76.931h-2.242a7.79 7.79 0 01-7.768-7.194l-.408-5.384a6.404 6.404 0 00-.222-1.267h3.167a6.467 6.467 0 016.454 5.976l.411 5.383c.064.857.269 1.697.608 2.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F0F9",
    d: "M211.02 42.734a4 4 0 014 4v30.2h-96.325a7.792 7.792 0 01-7.768-7.197l-.408-5.384a6.471 6.471 0 00-6.454-5.975h-27.73V46.734a4 4 0 014-4H211.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07538D",
    d: "M122.926 55.094v21.85h-1.989v-21.85a.99.99 0 01.288-.702.995.995 0 011.616.306.993.993 0 01.079.377l.006.019zM132.518 55.094v21.85h-1.989v-21.85a.996.996 0 011.698-.703c.186.186.291.439.291.703zM142.11 55.094v21.85h-1.992v-21.85a.996.996 0 01.994-.995.993.993 0 01.995.995h.003zM151.702 55.094v21.85h-1.989v-21.85a.996.996 0 01.988-.994c.264 0 .517.104.706.288.188.187.294.44.295.706zM161.294 55.094v21.85h-1.989v-21.85a.996.996 0 01.994-.995.993.993 0 01.995.995zM170.886 55.094v21.85h-1.989v-21.85a.99.99 0 01.988-.995c.264.002.517.105.706.289a1.008 1.008 0 01.295.706zM180.477 55.094v21.85h-1.988v-21.85a.992.992 0 01.994-.995.993.993 0 01.994.995zM190.069 55.094v21.85h-1.988v-21.85a.993.993 0 111.988 0zM235.119 98.38c-1.102.607-2.242 1.2-3.484 1.39-3.166.484-6.203-1.749-9.424-1.768a7.127 7.127 0 00-6.409 4.171c2.935.535 5.947.437 8.93.339l16.517-.554c1.207-.042 2.562-.149 3.341-1.068.494-.579.633-1.365.95-2.058.532-1.168 1.517-2.061 2.217-3.141.776-1.2 1.583-3.42 1.08-4.868-.713-1.995-2.635.377-3.712 1.166a92.028 92.028 0 01-10.006 6.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint0_linear)",
    d: "M250.335 61.402c0 .905.633 1.69.807 2.577.244 1.169-.288 2.48.285 3.525.633 1.165 2.217 1.289 3.449 1.811a4.943 4.943 0 012.881 4.988 1.06 1.06 0 00.07.728.95.95 0 00.712.295l3.085.316c.357.073.729.039 1.067-.098.308-.206.537-.51.652-.861.89-2.135.729-4.55 1.267-6.802.69-2.983 2.562-5.621 3.043-8.645a9.81 9.81 0 00-.792-5.634c-.506-1.09-1.266-2.121-2.359-2.619a6.625 6.625 0 00-2.438-.446c-3.132-.152-7.439.215-8.303 3.942-.288 1.267-.089 2.255-.915 3.37-.827 1.114-2.502 1.966-2.511 3.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272726",
    d: "M252.32 48.77c-.263 1.947 1.324 3.626 2.888 4.81 1.564 1.184 6.745 3.639 7.078 5.159.332 1.52.228 3.097.12 4.648.228.95 1.719-1.78 2.011-1.88 1.114-.76 1.422.373 1.513.785a1.9 1.9 0 01-.171 1.184c-.465 1.143-2.384 3.898-1.817 5.982 1.713.316 2.232-3.99 3.8-4.719 2.216-1.022 4.116-2.033 4.75-4.386.744-2.79 1.38-5.902.025-8.455a3.231 3.231 0 00-.849-1.067c-.316-.237-.68-.386-1.01-.595-.896-.56-1.46-1.507-2.125-2.328a10.72 10.72 0 00-6.298-3.768c-2.09-.393-4.655-.209-6.536.87-1.356.78-3.164 2.129-3.379 3.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07538D",
    d: "M268.261 109.425a48.123 48.123 0 002.027-4.712c2.236-6.403 1.685-13.402 1.004-20.15a14.496 14.496 0 00-.523-3.024 13.643 13.643 0 00-1.71-3.25 92.801 92.801 0 00-3.103-4.433c-.276-.367-.589-.756-1.036-.864a2.017 2.017 0 00-.95.085l-2.603.662c-2.324.592-4.845 1.314-6.225 3.278-4.241 6.016-7.968 12.907-10.289 19.9l-6.333 19.123c-.83 2.495-1.612 5.399-.187 7.6 1.681 2.597 5.383 2.711 8.461 2.533l5.479-.316c2.305-.13 4.851-.365 6.447-2.033a9.295 9.295 0 001.248-1.818c2.818-4.905 5.867-7.439 8.293-12.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F0F9",
    d: "M299.834 103H202a4 4 0 00-4 4v57.683a4 4 0 004 4h97.834a4 4 0 004-4V107a4 4 0 00-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M297.926 101.521h-97.834a4 4 0 00-4 4v57.683a4 4 0 004 4h97.834a4 4 0 004-4v-57.683a4 4 0 00-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint1_linear)",
    d: "M254.347 140.832c.474.149.974.199 1.469.145-.279.659.633 1.239 1.352 1.102.719-.136 1.305-.633 2.014-.706.38-.035.779.051 1.137-.088a1.7 1.7 0 00.744-.7c.776-1.147 1.267-2.461 1.723-3.759 1.067-2.958 1.843-6.039 3.205-8.867 4.75-9.874 5.272-24.247 5.196-26.496-.807.026-3.252.108-4.047.251a1.61 1.61 0 00-.744.275 1.525 1.525 0 00-.428.719c-.823 2.375-.611 4.962-.87 7.464-.618 5.991-3.905 11.346-5.555 17.138-.709 2.492-1.118 5.352-2.809 7.41-.392.478-1.073.95-1.336 1.498-.352.744.155 1.032.114 1.773-.019.288-1.526 2.727-1.165 2.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint2_linear)",
    d: "M218.905 106.153a5.759 5.759 0 002.495-.212 8.776 8.776 0 012.48-.408c.687.028 1.51.19 1.954-.336.579-.69-.098-1.919.516-2.578.152-.164.364-.263.516-.424a.448.448 0 00.07-.599.577.577 0 00-.377-.11 56.776 56.776 0 00-8.113.139c-.681.06-1.46.187-1.824.769-.868 1.381.994 3.5 2.283 3.759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07538D",
    d: "M216.752 157.729a1.002 1.002 0 01-.995-.994v-43.678c.002-.263.107-.515.293-.702a.985.985 0 011.081-.218c.121.049.23.122.323.213a.995.995 0 01.292.7v43.701a.999.999 0 01-.994.978zM226.353 157.729a.998.998 0 01-.994-.994v-43.678a1.002 1.002 0 01.994-.995.994.994 0 01.995.988v43.701a.999.999 0 01-.995.978zM235.945 157.729a.998.998 0 01-.994-.994v-43.678a1.002 1.002 0 01.994-.995.994.994 0 01.994.988v43.701a.998.998 0 01-.994.978zM245.537 157.729a.998.998 0 01-.994-.994v-43.678a1.002 1.002 0 01.994-.995.994.994 0 01.994.988v43.701a.998.998 0 01-.994.978zM255.129 157.729a.998.998 0 01-.994-.994v-43.678a.975.975 0 01.288-.702 1.002 1.002 0 01.7-.293 1.002 1.002 0 01.994.995v43.678a1.002 1.002 0 01-.988.994zM264.721 157.729a.998.998 0 01-.994-.994v-43.678a.975.975 0 01.288-.702.983.983 0 011.401 0c.186.187.291.439.293.702v43.678a1.002 1.002 0 01-.988.994zM274.313 157.729a.999.999 0 01-.995-.994v-43.678a.994.994 0 01.988-.995 1.003 1.003 0 01.995.995v43.678a1.002 1.002 0 01-.988.994zM283.905 112.062a1.002 1.002 0 01.994.995v43.678a1.002 1.002 0 01-.994.994.998.998 0 01-.995-.994v-43.678a1.003 1.003 0 01.995-.995z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0071C7",
    d: "M258.235 96.672a353.111 353.111 0 01-1.985 25.894c-.193 1.717-.396 3.484.07 5.146.19.684.633 2.616 1.086 3.167.633.801 1.403.114 2.416.222 1.51.161 2.074 1.022 2.954-.216.881-1.238 2.163-4.541 2.534-6.017a105.428 105.428 0 002.264-35.555c-.2-1.881-.466-3.8-1.324-5.485-.858-1.684-2.429-3.122-4.31-3.334-2.91-.317-4.658 2.137-4.433 4.686.355 3.911.877 7.537.728 11.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint3_linear)",
    d: "M217.255 100.675a1.991 1.991 0 00-.782.671c-.14.28-.221.585-.237.897-.143 1.19-.276 2.46.253 3.537a.397.397 0 00.149.187.34.34 0 00.209 0 .894.894 0 00.567-.494c.102-.239.167-.492.193-.751.165-1.042.317-2.087.491-3.132a5.938 5.938 0 00-.206 2.179c.069.737.382 1.43.89 1.97a.662.662 0 00.316.205c.317.061.545-.266.672-.554a7.758 7.758 0 00.652-3.556 5.938 5.938 0 00.633 3.483c.051.105.121.2.206.279a.906.906 0 00.573.139.82.82 0 00.551-.12.759.759 0 00.222-.38 8.198 8.198 0 00.39-3.239c.092 1.186.332 2.356.715 3.483.051.218.168.415.336.564a.765.765 0 001.001-.241c.206-.323.316-.697.316-1.08.048-.5-.161-1.02-.019-1.501 1.539-5.203-7.087-3.122-8.091-2.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint4_linear)",
    d: "M254.249 135.42c-.523.237-1.144.668-.998 1.222.114.431.652.605 1.093.539.44-.067.842-.292 1.266-.368a.563.563 0 01.494.089.563.563 0 01.136.298c.146.769-.266 1.529-.741 2.153-.475.624-1.032 1.213-1.266 1.96.563.285 1.244-.06 1.697-.5.453-.44.82-.995 1.387-1.267l-1.457 2.597c-.133.234-.259.548-.085.753.234.276.674.026.928-.231a16.716 16.716 0 002.02-2.489 8.257 8.257 0 00-.82 2.85c.44.048.754-.392.969-.779l1.267-2.302a4.7 4.7 0 01-.51 2.046c.662-.143.978-.877 1.194-1.517.595-1.761 1.197-3.572 1.118-5.431-.016-.405-.095-.864-.437-1.086a1.324 1.324 0 00-.722-.152c-2.477-.035-4.282.589-6.533 1.615z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B88E6",
    d: "M257.219 131.379c.044-.278.167-.537.355-.747a1.58 1.58 0 01.95-.317l2.425-.278c.605-.07 1.349-.076 1.679.44.148.293.199.626.145.95a10.648 10.648 0 01-.453 2.419c-.066.206-4.088.614-4.452.523-1.384-.371-.982-1.638-.649-2.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint5_linear)",
    d: "M257.219 131.379c.044-.278.167-.537.355-.747a1.58 1.58 0 01.95-.317l2.425-.278c.605-.07 1.349-.076 1.679.44.148.293.199.626.145.95a10.648 10.648 0 01-.453 2.419c-.066.206-4.088.614-4.452.523-1.384-.371-.982-1.638-.649-2.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B88E6",
    d: "M232.408 167.204l-7.391 24.877h6.682l13.914-24.877h-13.205zM264.892 167.204l7.394 24.877h-6.682l-13.917-24.877h13.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B88E6",
    d: "M231.334 197.329c-.633.161-1.304.316-1.928.13-.624-.187-1.143-.874-.906-1.508-1.507.396-2.904 1.153-4.411 1.549-2.47.652-5.067.316-7.6-.038a6.5 6.5 0 013.189-4.117c1.583-.849 3.423-1.001 5.209-1.134l3.43-.256c.687-.051 2.172-.469 2.77.019.599.487.646 5.244.247 5.355zM272.486 197.329c-.634.161-1.308.316-1.932.129-.624-.186-1.153-.874-.918-1.507-1.511.396-2.907 1.153-4.415 1.549-2.47.652-5.067.316-7.6-.038a6.5 6.5 0 013.192-4.117c1.583-.849 3.42-1.001 5.206-1.134l3.411-.253c.69-.051 2.175-.469 2.771.019.595.488.658 5.241.285 5.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint6_linear)",
    d: "M232.408 167.204l-7.391 24.877h6.682l13.914-24.877h-13.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint7_linear)",
    d: "M264.892 167.204l7.394 24.877h-6.682l-13.917-24.877h13.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint8_linear)",
    d: "M231.334 197.329c-.633.161-1.304.316-1.928.13-.624-.187-1.143-.874-.906-1.508-1.507.396-2.904 1.153-4.411 1.549-2.47.652-5.067.316-7.6-.038a6.5 6.5 0 013.189-4.117c1.583-.849 3.423-1.001 5.209-1.134l3.43-.256c.687-.051 2.172-.469 2.77.019.599.487.646 5.244.247 5.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint9_linear)",
    d: "M272.486 197.329c-.634.161-1.308.316-1.932.129-.624-.186-1.153-.874-.918-1.507-1.511.396-2.907 1.153-4.415 1.549-2.47.652-5.067.316-7.6-.038a6.5 6.5 0 013.192-4.117c1.583-.849 3.42-1.001 5.206-1.134l3.411-.253c.69-.051 2.175-.469 2.771.019.595.488.658 5.241.285 5.352z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear",
    x1: 250.335,
    x2: 267.77,
    y1: 63.096,
    y2: 63.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear",
    x1: 11639,
    x2: 12541.3,
    y1: 12648.6,
    y2: 12648.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear",
    x1: 6129.28,
    x2: 6168.77,
    y1: 914.796,
    y2: 1408.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear",
    x1: 5425.98,
    x2: 5706.16,
    y1: 3018.08,
    y2: 3018.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear",
    x1: 6096.22,
    x2: 6337.36,
    y1: 5402.18,
    y2: 5402.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear",
    x1: 4399.87,
    x2: 4353.76,
    y1: 1451.84,
    y2: 1671.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear",
    x1: 13352.6,
    x2: 11013.7,
    y1: 15458.9,
    y2: 21485.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear",
    x1: 14208.3,
    x2: 15971.2,
    y1: 15089.5,
    y2: 21667.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint8_linear",
    x1: 8925.26,
    x2: 8936.59,
    y1: 4360.88,
    y2: 5552.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint9_linear",
    x1: 10922.1,
    x2: 10933.4,
    y1: 4340.06,
    y2: 5530.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SaveFile);
export default ForwardRef;